module.exports = "\r\n<!-- created by AHMED HAYEL -->\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 384
// module chunks = 1